module.exports = __webpack_public_path__ + "img/project-structural.ba2c2609.svg";